import { render, staticRenderFns } from "./image-preview-section.vue?vue&type=template&id=c65652d4&scoped=true"
import script from "./image-preview-section.vue?vue&type=script&setup=true&lang=js"
export * from "./image-preview-section.vue?vue&type=script&setup=true&lang=js"
import style0 from "./image-preview-section.vue?vue&type=style&index=0&id=c65652d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c65652d4",
  null
  
)

export default component.exports